import React, { Component } from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import { Tabs, Card, Icon } from "antd";
import _ from 'lodash';

import BasicCompanyDetails from "../../../components/modals/companySetupSteps/basicCompanyDetails";
import Request from "../../../request";
import BankSetup from "../../../components/modals/companySetupSteps/bankSetup";
import LeadSetup from "../../../components/modals/companySetupSteps/leadSetup";
import FinanceSetup from "../../../components/modals/companySetupSteps/financeSetup";
import PayrollSettings from "../../../components/modals/companySetupSteps/payrollSettings";
import UniversitySetup from "../../../components/modals/companySetupSteps/universitySetup";
import IntegratonSetup from "../../../components/modals/companySetupSteps/integrations";

const { TabPane } = Tabs;

class AdvanceSettings extends Component {
  state = {
    activeTab: 0,
    countries: [],
    phoneCodes: [],
    bankArr: [],
  }

  callback = (activeTab) => {
    this.setState({ activeTab })
  }

  loadInitialData = async () => {
    let countryRes = await Request.getCountriesWithoutBusinessAuth({ results: 10000 });

    if (countryRes && !countryRes.error) {
      let countries = [];

      // ✅ Use a Set to track unique phone codes
      let uniquePhoneCodes = new Set();
      let phoneCodes = [];

      _.each(countryRes.data, (country) => {

        countries.push({
          _id: country._id,
          countryName: country.countryName,
          display: country.countryName
        });

        const code = country.countryPhoneCode;
        if (!code || typeof code !== 'string' || code.trim() === '') {
          return; // skip invalid / empty
        }
        if (!uniquePhoneCodes.has(code)) {
          uniquePhoneCodes.add(code);

          phoneCodes.push({
            _id: code,
            display: `${code}(${country.countryName})`
          });
        }
      });

      this.setState({ countries, phoneCodes });

    }
  };


  componentDidMount() {
    this.loadInitialData()
  }

  render() {
    let { phoneCodes } = this.state;
    const tabList = [
      {
        name: 'Company Details',
        component: BasicCompanyDetails,
        icon: 'shop'
      },
      {
        name: 'Bank Details',
        component: BankSetup,
        icon: 'bank'
      },
      {
        name: 'Lead Setup',
        component: LeadSetup,
        icon: 'usergroup-add'
      },
      {
        name: 'Finance Setup',
        component: FinanceSetup,
        icon: 'dollar'
      },
      {
        name: 'Payroll Setup',
        component: PayrollSettings,
        icon: 'team'
      },
      {
        name: 'University Setup',
        component: UniversitySetup,
        icon: 'bank'
      },
      {
        name: 'Integration',
        component: IntegratonSetup,
        icon: 'api'
      }
    ];

    return (
      <PageHeaderWrapper title="System Setup Settings">
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={String(this.state.activeTab)}>
            {
              tabList.map((tab, index) => {
                const Component = tab.component;

                return (
                  <TabPane
                    key={String(index)}
                    tab={
                      <span>
                        <Icon type={tab.icon} style={{ marginRight: 5 }} />
                        {tab.name}
                      </span>
                    }
                  >
                    <Component phoneCodes={phoneCodes} isModal={false} />
                  </TabPane>
                );
              })
            }
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    )
  }
}




const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdvanceSettings);